import { createElement } from "react";
import React from "react";
import { useCtx } from "../Context.jsx";
import { reactApi } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { startAsPromise } from "../fable_modules/fable-library-js.4.29.0/Async.js";
import { toastServerError, Track } from "../ApiClient.jsx";
import { successToast, infoToast, errorToast } from "../Toasts.jsx";
import { useEffectOnce } from "../fable_modules/Feliz.2.9.0/Internal.fs.js";
import { int32ToString, createObj } from "../fable_modules/fable-library-js.4.29.0/Util.js";
import { collect, toArray, singleton, append, delay, toList } from "../fable_modules/fable-library-js.4.29.0/Seq.js";
import { DataGridCell, DataGridBody, DataGridHeader, DataGridHeaderCell, DataGridRow, DataGrid, Button, Text as Text$, Persona, Link, TableCellLayout, createTableColumn as createTableColumn_4, Title3 } from "@fluentui/react-components";
import { compare } from "../fable_modules/fable-library-js.4.29.0/String.js";
import { RouterModule_encodeParts } from "../fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import { isEmpty, singleton as singleton_1, ofArray } from "../fable_modules/fable-library-js.4.29.0/List.js";
import { map, defaultArg } from "../fable_modules/fable-library-js.4.29.0/Option.js";
import { reactApi as reactApi_1 } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { ArrowExitRegular } from "@fluentui/react-icons";
import { tap } from "../fable_modules/Fable.Promise.3.2.0/Promise.fs.js";
import { dataGrid_items_Z6D8BD2B8 } from "../fable_modules/FS.FluentUI.3.0.0/Props2.fs.js";

export function View(viewInputProps) {
    let elems_5;
    const trackId = viewInputProps.trackId;
    const setCtx = useCtx()[1];
    const patternInput_1 = reactApi.useState([]);
    const getEnrolledUsers = () => {
        let pr_1;
        const pr = startAsPromise(Track.GetUsersEnrolledInTrack(trackId));
        pr_1 = (pr.then((res) => {
            if (res.tag === 1) {
                errorToast(setCtx, "getEnrolledUsersNotFound", "Kunne ikke hente brukere", "Læringsløpet finnes ikke", undefined);
            }
            else {
                patternInput_1[1](res.fields[0]);
            }
        }));
        void (pr_1.catch((ex) => {
            toastServerError(setCtx, ex);
        }));
    };
    useEffectOnce(() => {
        const value = getEnrolledUsers();
    });
    return createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        gap: 16 + "px ",
    }], (elems_5 = toList(delay(() => {
        let el;
        return append(singleton((el = Title3, createElement(el, {
            children: "Påmeldte brukere",
        }))), delay(() => {
            let createTableColumn, createTableColumn_1, createTableColumn_2, createTableColumn_3, elems_4, el_32, value_137, elems_3, props_39, el_24, name_5, el_30;
            const columns = ofArray([(createTableColumn = createTableColumn_4, createTableColumn({
                columnId: "name",
                compare: (delegateArg, delegateArg_1) => {
                    const a_2 = delegateArg;
                    const b = delegateArg_1;
                    return compare(`${a_2.FirstName} ${a_2.LastName}`, `${b.FirstName} ${b.LastName}`) | 0;
                },
                renderHeaderCell: () => "Navn",
                renderCell: (delegateArg_3) => {
                    let elems_1, el_6, elems, el_4, el_2;
                    const user_1 = delegateArg_3;
                    const el_8 = TableCellLayout;
                    return createElement(el_8, {
                        key: `${user_1.Id}-name`,
                        children: singleton_1(createElement("div", createObj(ofArray([["style", {
                            display: "flex",
                            alignItems: "center",
                            gap: 8 + "px ",
                            height: 100 + "%",
                        }], (elems_1 = [(el_6 = Link, createElement(el_6, createObj(ofArray([["href", RouterModule_encodeParts(ofArray(["bruker", int32ToString(user_1.Id)]), 1)], (elems = [(el_4 = Persona, createElement(el_4, {
                            size: "small",
                            textAlignment: "center",
                            avatar: {
                                image: {
                                    src: defaultArg(user_1.ThumbnailUrl, ""),
                                },
                            },
                            primaryText: (el_2 = Text$, createElement(el_2, {
                                children: `${user_1.FirstName} ${user_1.LastName}`,
                                style: {
                                    maxWidth: 180,
                                    display: "inline-block",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                },
                                wrap: false,
                            })),
                        }))], ["children", reactApi_1.Children.toArray(Array.from(elems))])]))))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))),
                    });
                },
            })), (createTableColumn_1 = createTableColumn_4, createTableColumn_1({
                columnId: "email",
                compare: (delegateArg_4, delegateArg_1_1) => compare(delegateArg_4.Email, delegateArg_1_1.Email),
                renderHeaderCell: () => "E-post",
                renderCell: (delegateArg_6) => {
                    let el_10;
                    const user_2 = delegateArg_6;
                    const el_12 = TableCellLayout;
                    return createElement(el_12, {
                        key: `${user_2.Id}-email`,
                        style: {
                            maxWidth: 380,
                            wordBreak: "break-all",
                        },
                        children: singleton_1((el_10 = Text$, createElement(el_10, {
                            children: user_2.Email,
                        }))),
                    });
                },
            })), (createTableColumn_2 = createTableColumn_4, createTableColumn_2({
                columnId: "workplace",
                renderHeaderCell: () => "Arbeidsplass",
                renderCell: (delegateArg_8) => {
                    let el_14;
                    const user_3 = delegateArg_8;
                    const el_16 = TableCellLayout;
                    return createElement(el_16, {
                        key: `${user_3.Id}-workplace`,
                        children: singleton_1((el_14 = Text$, createElement(el_14, {
                            children: defaultArg(map((w) => w.Name, user_3.Workplace), "_"),
                        }))),
                    });
                },
            })), (createTableColumn_3 = createTableColumn_4, createTableColumn_3({
                columnId: "actions",
                renderHeaderCell: () => "",
                renderCell: (delegateArg_10) => {
                    let el_20, el_18;
                    const user_4 = delegateArg_10;
                    const el_22 = TableCellLayout;
                    return createElement(el_22, {
                        key: `${user_4.Id}-actions`,
                        children: singleton_1((el_20 = Button, createElement(el_20, {
                            size: "small",
                            icon: (el_18 = ArrowExitRegular, createElement(el_18, {})),
                            iconPosition: "after",
                            children: "Meld av",
                            onClick: (_arg_4) => {
                                const user = user_4;
                                const pr_2 = tap((res_1) => {
                                    if (res_1.tag === 1) {
                                        if (res_1.fields[0].tag === 1) {
                                            infoToast(setCtx, "notSignedUpError", "Ikke påmeldt", `${user.FirstName} ${user.LastName} er ikke påmeldt læringsløpet`, undefined);
                                        }
                                        else {
                                            errorToast(setCtx, "signOffError", "Kunne ikke melde av", "Noe gikk galt", undefined);
                                        }
                                    }
                                    else {
                                        getEnrolledUsers();
                                        successToast(setCtx, "signOffSuccess", "Avmeldt", `${user.FirstName} ${user.LastName} ble avmeldt`);
                                    }
                                }, startAsPromise(Track.SignOff(trackId, user.Id)));
                                void (pr_2.catch((ex_1) => {
                                    toastServerError(setCtx, ex_1);
                                }));
                            },
                        }))),
                    });
                },
            }))]);
            return singleton(createElement("div", createObj(ofArray([["style", {
                width: 100 + "%",
                overflowX: "auto",
            }], (elems_4 = [(el_32 = DataGrid, createElement(el_32, createObj(ofArray([dataGrid_items_Z6D8BD2B8(patternInput_1[0]), ["columns", toArray(columns)], ["getRowId", (delegateArg_11) => delegateArg_11.Id], ["sortable", true], ["resizableColumns", true], (value_137 = ofArray([["name", ofArray([["minWidth", 150], ["defaultWidth", 180], ["idealWidth", 250]])], ["email", ofArray([["minWidth", 180], ["defaultWidth", 200], ["idealWidth", 300]])], ["workplace", ofArray([["minWidth", 120], ["defaultWidth", 150], ["idealWidth", 200]])], ["actions", ofArray([["minWidth", 120], ["defaultWidth", 150], ["idealWidth", 200]])]]), ["columnSizingOptions", isEmpty(value_137) ? {} : createObj(toList(delay(() => collect((matchValue) => singleton([matchValue[0], createObj(matchValue[1])]), value_137))))]), (elems_3 = [(props_39 = singleton_1((el_24 = DataGridRow, createElement(el_24, {
                children: (delegateArg_12, delegateArg_1_2) => {
                    const props_34 = singleton_1(delegateArg_12.renderHeaderCell());
                    const name_3 = DataGridHeaderCell;
                    return createElement(name_3, {
                        children: reactApi.Children.toArray(Array.from(props_34)),
                    });
                },
            }))), (name_5 = DataGridHeader, createElement(name_5, {
                children: reactApi.Children.toArray(Array.from(props_39)),
            }))), (el_30 = DataGridBody, createElement(el_30, {
                children: (delegateArg_14) => {
                    const trd = delegateArg_14;
                    const el_28 = DataGridRow;
                    return createElement(el_28, {
                        key: trd.rowId,
                        children: (delegateArg_13, delegateArg_1_3) => {
                            let elems_2;
                            const tcd_1 = delegateArg_13;
                            const el_26 = DataGridCell;
                            return createElement(el_26, createObj(ofArray([["key", tcd_1.columnId], (elems_2 = [tcd_1.renderCell(trd.item)], ["children", reactApi_1.Children.toArray(Array.from(elems_2))])])));
                        },
                    });
                },
            }))], ["children", reactApi_1.Children.toArray(Array.from(elems_3))])]))))], ["children", reactApi.Children.toArray(Array.from(elems_4))])]))));
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_5))])])));
}

//# sourceMappingURL=TrackEnrolledUsers.jsx.map
